import { useEffect, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import SoftBox from "../../common/softBox";
import { useSoftUIController, setLayout } from "../../../context";

interface PageLayoutProps {
  background?: "white" | "light" | "default";
  children: ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ background = "default", children }) => {
  const [, dispatch] = useSoftUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname, dispatch]);

  return (
    <SoftBox
      width="100vw"
      height="100%"
      minHeight="100vh"
      bgColor={background}
      sx={{ overflowX: "hidden" }}
    >
      {children}
    </SoftBox>
  );
};

export default PageLayout;